<script lang="ts">
  import StatusTag from "@kontextwerk/web-sdk/ui/display/StatusTag.svelte"
  import { RICH_TOOLTIP_CLASS } from "../../../../../../../../../_shared/_logic/rich-tooltips"
  import type { ContactOrderPlanRow } from "../../../../_logic/communication-plan-table-contract"

  let { row }: { row: ContactOrderPlanRow } = $props()
</script>

<span class="unified-status-cell">
  <StatusTag
    size="sm"
    status={row.statusDefinition}
    subLabel={row.statusSubLabel ?? undefined}
    tooltipContent={row.statusTooltip}
    tooltipHtml={true}
    tooltipClassName={RICH_TOOLTIP_CLASS}
    disableTitle={true}
  />
</span>

<style lang="less">
  .unified-status-cell {
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.22rem;
    min-width: 0;
  }
</style>
